<template>

    <div v-show="checkIfShowTextarea"
            @ps-y-reach-end="reachEnd"
            :settings="{minScrollbarLength: 20}"
            :style="{height: height + 'px'}"
            class="scroll-area"
            v-scroll:debounce="{fn: onScroll, debounce: 130 }"
            :class="{'scroll-area-force-visible-y-bar':true}"
            v-html="paragraph.text">
    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
// import _delay from 'lodash/delay'
// import rx from 'rx-lite-dom'

const desktopHeight = 85
const mobileHeight = 160

export default {
  name: 'PrivacyScrollerSimple',
  mounted () {
    this.paragraph.scrolled = false
    this.height = this.$el.clientHeight
    // console.log('---- scroller mounted')
    if (!this.height || this.height === 0) {
      this.height = desktopHeight
    }

    if (!this.greaterThan600) {
      this.height = mobileHeight
    }

    /* rx.DOM
        .fromMutationObserver(this.$el, {attributes: true, _attributeFilter: ['target.scrollTop']})
        .subscribe(o => {
          try {
            console.dir(o)
          } catch (e) {}
        }) */

    this.checkScrolled()
    this.$el.scrollTop = 1
    this.inited = true

    this.$nextTick(() => {
      this.needYScroll = this.$el.scrollTop + this.height + 5 <= this.$el.scrollHeight
    })
  },
  watch: {
    started () {
      this.init()
    }
  },
  data () {
    return {
      height: window.innerWidth > 600 ? desktopHeight : mobileHeight,
      isEnd: false,
      inited: false,
      cmpStarted: false,
      greaterThan600: window.innerWidth > 600,
      needYScroll: true
    }
  },
  methods: {
    init () {
      if (this.cmpStarted) {
        return ''
      }
      this.paragraph.scrolled = false
      if (!this.greaterThan600) {
        this.height = mobileHeight
      } else {
        this.height = desktopHeight
      }
      this.checkScrolled()
      return ''
    },
    reachEnd () {

    },
    checkScrolled () {
      if (!this.$el) {
        console.log('--- checkScrolled with $el not mounted')
        return
      }

      if (this.noMandatoryFields) {
        if (!this.paragraph.scrolled) {
          this.paragraph.scrolled = true
        }
        return
      }

      this.isEnd = this.$el.scrollTop + this.height + 5 >= this.$el.scrollHeight

      if (this.isEnd) {
        this.$emit('scrolled', true)
        this.paragraph.scrolled = true
      } else {
        if (!this.paragraph.scrolled) {
          this.$emit('scrolled', false)
          this.paragraph.scrolled = false
        }
      }
    },
    onScroll () {
      this.checkScrolled()
    }
  },
  computed: {
    ...mapState(['started']),
    ...mapGetters(['paragraphHasNoMandatoryFlags']),
    noMandatoryFields () {
      return this.paragraphHasNoMandatoryFlags(this.paragraph)
    },
    checkIfShowTextarea () {
      return this.paragraph.text.toLowerCase().indexOf(this.$store.state.tagNoShow) === -1
    }
  },
  created () {
    this.paragraph.scrolled = false
    this.cmpStarted = true
  },
  props: {
    paragraph: {type: Object}
  }
}
</script>

<style lang="scss">
    .privacy-scroller {
        text-align: left;
        padding: 2px 10px;
        min-height: 50px;
        font-family: arial;
        font-size: 11px;
    }

    .scroll-area-force-visible-y-bar {
        .ps__scrollbar-y-rail {
            opacity: 1 !important;
            background-color: rgb(238,238,238) !important;
            width:12px;
            .ps__scrollbar-y {
                max-width:6px;
            }
        }
    }

    .scroll-area {
        overflow-y: scroll;
        overflow: -moz-scrollbars-vertical;
        background: white;
        border:1px solid silver;
        position: relative;
        margin: auto;
        margin-bottom:3px !important;
        width: auto;
        min-height: 50px;
        font-family: arial;
        font-size: 11px;
    }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyScrollerSimple.vue